import React, { useEffect, useState, useRef, useMemo } from "react";
import {
    Box,
    Container,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    IconButton,
    Typography,
    Chip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    MenuItem,
    FormControl,
    InputLabel,
    Select,
    Tooltip,
    Stack,
    CircularProgress,
    Card,
    CardContent,
    Divider,
    Tab,
    Tabs,
    InputAdornment
} from "@mui/material";
import {
    Campaign as CampaignIcon,
    Add as AddIcon,
    Edit as EditIcon,
    Delete as DeleteIcon,
    CloudUpload as CloudUploadIcon,
    Close as CloseIcon,
    Image as ImageIcon,
    VolumeUp as VolumeUpIcon,
    Search as SearchIcon,
    CheckCircle as CheckCircleIcon,
    Cancel as CancelIcon,
    PhotoLibrary as PhotoLibraryIcon
} from "@mui/icons-material";
import swal from "sweetalert";
import { t } from "i18next";
import axios from "axios";
import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import "./account.css";
import { theme } from "../../theme";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const formats = ["header", "bold", "italic", "underline", "strike", "blockquote", "list", "bullet", "indent", "link", "image"];

const formatImageUrl = (url) => {
    if (!url) return "";
    if (url.startsWith("data:") || url.startsWith("blob:")) {
        return url;
    }
    if (url.startsWith("/")) {
        const apiBase = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL.replace(/\/api\/?$/, "") : "";
        return `${apiBase}${url}`;
    }
    return url;
};

function SettingNotify() {
    const [notify, setNotify] = useState([]);
    const [load, setLoad] = useState(true);
    const [profile] = useState(JSON.parse(localStorage.getItem("profile")));

    // Modal State
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalMode, setModalMode] = useState("create"); // "create" | "edit"
    const [notifyItem, setNotifyItem] = useState(null);
    const [selectedTitle, setSelectedTitle] = useState("popup");
    const [content, setContent] = useState("");
    const [imageUrl, setImageUrl] = useState("");
    const [uploading, setUploading] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    // Filters
    const [filterType, setFilterType] = useState("all");
    const [searchQuery, setSearchQuery] = useState("");

    const reactQuillRef = useRef(null);

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    const fetchNotify = () => {
        setLoad(true);
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getnotify`, {})
            .then((res) => {
                setNotify(res.data.data || []);
                setLoad(false);
            })
            .catch(() => setLoad(false));
    };

    useEffect(() => {
        fetchNotify();
    }, []);

    useEffect(() => {
        if (load) {
            fetchNotify();
        }
    }, [load]);

    const handleOpenCreateModal = () => {
        setModalMode("create");
        setNotifyItem(null);
        setSelectedTitle("popup");
        setContent("");
        setImageUrl("");
        setIsModalOpen(true);
    };

    const handleOpenEditModal = (item) => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/notifyall/${item._id}`, {})
            .then((res) => {
                const data = res.data.data;
                setNotifyItem(data);
                setSelectedTitle(data?.title || "popup");
                setContent(data?.content || "");
                setImageUrl(data?.image || "");
                setModalMode("edit");
                setIsModalOpen(true);
            })
            .catch(() => {
                setNotifyItem(item);
                setSelectedTitle(item?.title || "popup");
                setContent(item?.content || "");
                setImageUrl(item?.image || "");
                setModalMode("edit");
                setIsModalOpen(true);
            });
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        setSubmitting(true);

        if (modalMode === "create") {
            const formData = {
                title: selectedTitle || "popup",
                image: imageUrl,
                content: content
            };
            axios
                .post(`${process.env.REACT_APP_API_URL}/auth/newnotify`, formData)
                .then(() => {
                    setSubmitting(false);
                    swal(t("success"), "Thêm thông báo mới thành công", "success").then(() => {
                        setIsModalOpen(false);
                        setContent("");
                        setImageUrl("");
                        setLoad(true);
                    });
                })
                .catch(() => {
                    setSubmitting(false);
                    swal("Lỗi", "Không thể thêm thông báo mới", "error");
                });
        } else {
            const formData = {
                id: notifyItem._id,
                title: selectedTitle || notifyItem.title,
                image: imageUrl,
                content: content
            };

            axios
                .post(`${process.env.REACT_APP_API_URL}/auth/editlistnotify`, formData)
                .then(() => {
                    setSubmitting(false);
                    swal(t("success"), "Cập nhật thông báo thành công", "success").then(() => {
                        setIsModalOpen(false);
                        setLoad(true);
                    });
                })
                .catch(() => {
                    setSubmitting(false);
                    swal("Lỗi", "Không thể cập nhật thông báo", "error");
                });
        }
    };

    const handleUploadFile = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setUploading(true);
        const formData = new FormData();
        formData.append("file", file);

        axios
            .post(`${process.env.REACT_APP_API_URL}/lobby/upload`, formData, {
                headers: { "Content-Type": "multipart/form-data" }
            })
            .then((res) => {
                setUploading(false);
                if (res.data?.data?.url) {
                    setImageUrl(res.data.data.url);
                    swal(t("success"), "Tải ảnh lên thành công", "success");
                } else if (res.data?.url) {
                    setImageUrl(res.data.url);
                    swal(t("success"), "Tải ảnh lên thành công", "success");
                }
            })
            .catch(() => {
                setUploading(false);
                swal("Lỗi", "Không thể tải ảnh lên", "error");
            });
    };

    const handleToggleShow = (item) => {
        axios
            .post(`${process.env.REACT_APP_API_URL}/auth/editlistnotify`, {
                id: item._id,
                isShow: !item.isShow
            })
            .then(() => setLoad(true))
            .catch(() => swal("Lỗi", "Không thể thay đổi trạng thái", "error"));
    };

    const handleDeleteNotify = (item) => {
        swal({
            title: "Bạn có chắc chắn muốn xoá?",
            text: "Thông báo này sẽ bị gỡ bỏ khỏi hệ thống.",
            icon: "warning",
            buttons: ["Hủy", "Xóa"],
            dangerMode: true
        }).then((willDelete) => {
            if (willDelete) {
                axios
                    .post(`${process.env.REACT_APP_API_URL}/auth/deletenotify`, {
                        id: item._id
                    })
                    .then(() => {
                        swal("Thành công", "Xóa thông báo thành công", "success");
                        setLoad(true);
                    })
                    .catch(() => swal("Lỗi", "Không thể xóa thông báo", "error"));
            }
        });
    };

    const modules = useMemo(
        () => ({
            toolbar: {
                container: [
                    [{ header: [1, 2, false] }],
                    ["bold", "italic", "underline", "strike", "blockquote"],
                    [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
                    ["link", "image"],
                    ["clean"]
                ]
            }
        }),
        []
    );

    const marqueeItem = useMemo(() => {
        if (!notify || notify.length === 0) return null;
        return notify.find((item) => item.title === "marquee") || (notify[0]?.title === "marquee" ? notify[0] : null);
    }, [notify]);

    const listItems = useMemo(() => {
        if (!notify || notify.length === 0) return [];
        return notify.filter((item) => item !== marqueeItem);
    }, [notify, marqueeItem]);

    const filteredList = useMemo(() => {
        return listItems.filter((item, index) => {
            const matchesFilter =
                filterType === "all"
                    ? true
                    : filterType === "banner_login"
                    ? item.title === "banner_login" || index === 0
                    : item.title === filterType;
            const matchesSearch =
                !searchQuery ||
                (item.title && item.title.toLowerCase().includes(searchQuery.toLowerCase())) ||
                (item.content && item.content.toLowerCase().includes(searchQuery.toLowerCase()));
            return matchesFilter && matchesSearch;
        });
    }, [listItems, filterType, searchQuery]);

    const renderTitleChip = (title, index) => {
        if (title === "banner_login" || index === 0) {
            return (
                <Chip
                    label="Banner Đăng Nhập"
                    size="small"
                    sx={{
                        fontWeight: 600,
                        bgcolor: "rgba(147, 51, 234, 0.1)",
                        color: "#9333ea",
                        border: "1px solid rgba(147, 51, 234, 0.3)"
                    }}
                />
            );
        }
        if (title === "popup") {
            return (
                <Chip
                    label="Popup Thông Báo"
                    size="small"
                    sx={{
                        fontWeight: 600,
                        bgcolor: "rgba(225, 29, 72, 0.1)",
                        color: "#e11d48",
                        border: "1px solid rgba(225, 29, 72, 0.3)"
                    }}
                />
            );
        }
        if (title === "banner") {
            return (
                <Chip
                    label="Banner Trang Chủ"
                    size="small"
                    sx={{
                        fontWeight: 600,
                        bgcolor: "rgba(37, 99, 235, 0.1)",
                        color: "#2563eb",
                        border: "1px solid rgba(37, 99, 235, 0.3)"
                    }}
                />
            );
        }
        if (title === "marquee") {
            return (
                <Chip
                    label="Dòng Chạy (Marquee)"
                    size="small"
                    sx={{
                        fontWeight: 600,
                        bgcolor: "rgba(217, 119, 6, 0.1)",
                        color: "#d97706",
                        border: "1px solid rgba(217, 119, 6, 0.3)"
                    }}
                />
            );
        }
        return (
            <Chip
                label={title || "Chưa phân loại"}
                size="small"
                sx={{
                    fontWeight: 600,
                    bgcolor: "rgba(71, 85, 105, 0.1)",
                    color: "#475569",
                    border: "1px solid rgba(71, 85, 105, 0.3)"
                }}
            />
        );
    };

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                {profile?.permission?.full == 1 || profile?.isReadOnly || profile?.permission?.readonly == 1 ? (
                    <Box component="main" sx={{ flexGrow: 1, py: 4, px: 3, bgcolor: "#f8fafc", minHeight: "100vh" }}>
                        <Container maxWidth={false}>
                            {/* PAGE HEADER */}
                            <Box sx={{ mb: 4 }}>
                                <Typography variant="h4" sx={{ fontWeight: 800, color: "#0f172a", fontSize: { xs: "22px", md: "26px" } }}>
                                    Cài Đặt Thông Báo & Banner
                                </Typography>
                                <Typography variant="body2" sx={{ color: "#64748b", mt: 0.5 }}>
                                    Quản lý dòng chữ chạy marquee, banner quảng cáo slider và popup thông báo hệ thống.
                                </Typography>
                            </Box>

                            {/* DÒNG CHẠY (MARQUEE) PLAYER CARD */}
                            {marqueeItem && (
                                <Card
                                    sx={{
                                        mb: 4,
                                        borderRadius: "14px",
                                        border: "1px solid #e2e8f0",
                                        boxShadow: "0 4px 20px -2px rgba(0, 0, 0, 0.05)",
                                        background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                                        overflow: "hidden"
                                    }}
                                >
                                    <CardContent sx={{ p: 2.5, "&:last-child": { pb: 2.5 } }}>
                                        <Stack direction={{ xs: "column", sm: "row" }} alignItems={{ xs: "flex-start", sm: "center" }} justifyContent="space-between" spacing={2} mb={1.5}>
                                            <Stack direction="row" alignItems="center" spacing={1}>
                                                <VolumeUpIcon sx={{ color: "#e11d48", fontSize: 24 }} />
                                                <Typography variant="h6" sx={{ fontWeight: 700, fontSize: "16px", color: "#0f172a" }}>
                                                    Dòng Chạy Thông Báo (Marquee Top Bar)
                                                </Typography>
                                                <Chip label="Đang hoạt động" size="small" color="success" sx={{ height: 22, fontSize: "11px", fontWeight: 600 }} />
                                            </Stack>
                                            <Button
                                                variant="outlined"
                                                color="primary"
                                                startIcon={<EditIcon />}
                                                size="small"
                                                onClick={() => handleOpenEditModal(marqueeItem)}
                                                sx={{
                                                    borderRadius: "8px",
                                                    textTransform: "none",
                                                    fontWeight: 600,
                                                    px: 2
                                                }}
                                            >
                                                Chỉnh sửa dòng chạy
                                            </Button>
                                        </Stack>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                bgcolor: "#0f172a",
                                                color: "#f8fafc",
                                                borderRadius: "10px",
                                                px: 2,
                                                py: 1.2,
                                                border: "1px solid #334155",
                                                boxShadow: "inset 0 2px 4px rgba(0,0,0,0.4)"
                                            }}
                                        >
                                            <marquee className="thongbaomarquee" style={{ fontSize: "14px", fontWeight: 500 }}>
                                                <div className="contentHtml" dangerouslySetInnerHTML={{ __html: marqueeItem.content || "Chưa có nội dung thông báo chữ chạy" }} />
                                            </marquee>
                                        </Box>
                                    </CardContent>
                                </Card>
                            )}

                            {/* BANNER & NOTIFICATION TABLE CARD */}
                            <Card
                                sx={{
                                    borderRadius: "14px",
                                    border: "1px solid #e2e8f0",
                                    boxShadow: "0 4px 20px -2px rgba(0, 0, 0, 0.05)",
                                    bgcolor: "#ffffff"
                                }}
                            >
                                <CardContent sx={{ p: 3 }}>
                                    {/* Header & New Button */}
                                    <Stack direction={{ xs: "column", sm: "row" }} justifyContent="space-between" alignItems={{ xs: "flex-start", sm: "center" }} spacing={2} mb={3}>
                                        <Stack direction="row" alignItems="center" spacing={1.5}>
                                            <CampaignIcon sx={{ color: "#2563eb", fontSize: 28 }} />
                                            <Box>
                                                <Typography variant="h6" sx={{ fontWeight: 700, fontSize: "18px", color: "#0f172a" }}>
                                                    Danh Sách Banner & Thông Báo
                                                </Typography>
                                                <Typography variant="body2" sx={{ color: "#64748b", fontSize: "13px" }}>
                                                    Tổng số {filteredList.length} thông báo / banner hiển thị
                                                </Typography>
                                            </Box>
                                        </Stack>
                                        <Button
                                            variant="contained"
                                            startIcon={<AddIcon />}
                                            onClick={handleOpenCreateModal}
                                            sx={{
                                                background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                                                color: "#ffffff",
                                                borderRadius: "8px",
                                                px: 2.5,
                                                py: 1,
                                                fontWeight: 600,
                                                fontSize: "14px",
                                                textTransform: "none",
                                                boxShadow: "0 4px 12px rgba(16, 185, 129, 0.25)",
                                                "&:hover": {
                                                    background: "linear-gradient(135deg, #059669 0%, #047857 100%)"
                                                }
                                            }}
                                        >
                                            + Thêm mới thông báo
                                        </Button>
                                    </Stack>

                                    {/* Filters & Search */}
                                    <Stack direction={{ xs: "column", md: "row" }} justifyContent="space-between" alignItems="center" spacing={2} mb={3}>
                                        <Tabs
                                            value={filterType}
                                            onChange={(e, val) => setFilterType(val)}
                                            sx={{
                                                minHeight: 40,
                                                "& .MuiTab-root": {
                                                    minHeight: 40,
                                                    textTransform: "none",
                                                    fontWeight: 600,
                                                    fontSize: "13px",
                                                    borderRadius: "8px",
                                                    px: 2,
                                                    mr: 1
                                                }
                                            }}
                                        >
                                            <Tab label="Tất cả" value="all" />
                                            <Tab label="Popup" value="popup" />
                                            <Tab label="Banner Trang Chủ" value="banner" />
                                            <Tab label="Banner Đăng Nhập" value="banner_login" />
                                        </Tabs>
                                        <TextField
                                            size="small"
                                            placeholder="Tìm kiếm thông báo..."
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <SearchIcon sx={{ color: "#94a3b8", fontSize: 20 }} />
                                                    </InputAdornment>
                                                )
                                            }}
                                            sx={{ width: { xs: "100%", md: 280 } }}
                                        />
                                    </Stack>

                                    {/* Data Table */}
                                    <TableContainer component={Paper} elevation={0} sx={{ border: "1px solid #e2e8f0", borderRadius: "10px", overflow: "hidden" }}>
                                        <Table sx={{ width: "100%" }}>
                                            <TableHead sx={{ bgcolor: "#f8fafc" }}>
                                                <TableRow>
                                                    <TableCell sx={{ fontWeight: 700, color: "#334155", py: 1.5, width: "18%" }}>Vị trí / Loại</TableCell>
                                                    <TableCell sx={{ fontWeight: 700, color: "#334155", py: 1.5, width: "22%" }}>Hình ảnh Banner</TableCell>
                                                    <TableCell sx={{ fontWeight: 700, color: "#334155", py: 1.5, width: "35%" }}>Nội dung thông báo</TableCell>
                                                    <TableCell sx={{ fontWeight: 700, color: "#334155", py: 1.5, width: "12%", textAlign: "center" }}>Trạng thái</TableCell>
                                                    <TableCell sx={{ fontWeight: 700, color: "#334155", py: 1.5, width: "13%", textAlign: "center" }}>Thao tác</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {load ? (
                                                    <TableRow>
                                                        <TableCell colSpan={5} align="center" sx={{ py: 6 }}>
                                                            <CircularProgress size={32} color="primary" />
                                                            <Typography variant="body2" sx={{ mt: 1, color: "#64748b" }}>Đang tải dữ liệu...</Typography>
                                                        </TableCell>
                                                    </TableRow>
                                                ) : filteredList.length > 0 ? (
                                                    filteredList.map((item, idx) => {
                                                        const formattedImg = formatImageUrl(item.image);
                                                        return (
                                                            <TableRow key={item._id || idx} hover sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                                                                <TableCell sx={{ py: 2 }}>
                                                                    {renderTitleChip(item.title, idx)}
                                                                </TableCell>
                                                                <TableCell sx={{ py: 2 }}>
                                                                    {item.image ? (
                                                                        <Box
                                                                            sx={{
                                                                                position: "relative",
                                                                                width: 140,
                                                                                height: 70,
                                                                                borderRadius: "8px",
                                                                                overflow: "hidden",
                                                                                border: "1px solid #e2e8f0",
                                                                                boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                                                                                bgcolor: "#f1f5f9"
                                                                            }}
                                                                        >
                                                                            <img
                                                                                src={formattedImg}
                                                                                alt={item.title}
                                                                                style={{
                                                                                    width: "100%",
                                                                                    height: "100%",
                                                                                    objectFit: "cover"
                                                                                }}
                                                                                onError={(e) => {
                                                                                    e.target.onerror = null;
                                                                                    e.target.style.display = "none";
                                                                                    if (e.target.nextSibling) {
                                                                                        e.target.nextSibling.style.display = "flex";
                                                                                    }
                                                                                }}
                                                                            />
                                                                            <Box
                                                                                sx={{
                                                                                    display: "none",
                                                                                    position: "absolute",
                                                                                    top: 0,
                                                                                    left: 0,
                                                                                    width: "100%",
                                                                                    height: "100%",
                                                                                    alignItems: "center",
                                                                                    justifyContent: "center",
                                                                                    flexDirection: "column",
                                                                                    bgcolor: "#f1f5f9",
                                                                                    color: "#94a3b8"
                                                                                }}
                                                                            >
                                                                                <ImageIcon sx={{ fontSize: 24 }} />
                                                                                <Typography variant="caption" sx={{ fontSize: "10px" }}>Lỗi ảnh</Typography>
                                                                            </Box>
                                                                        </Box>
                                                                    ) : (
                                                                        <Box
                                                                            sx={{
                                                                                width: 140,
                                                                                height: 70,
                                                                                borderRadius: "8px",
                                                                                border: "1px dashed #cbd5e1",
                                                                                bgcolor: "#f8fafc",
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                justifyContent: "center",
                                                                                flexDirection: "column",
                                                                                color: "#94a3b8"
                                                                            }}
                                                                        >
                                                                            <ImageIcon sx={{ fontSize: 24, mb: 0.5 }} />
                                                                            <Typography variant="caption" sx={{ fontSize: "11px", fontWeight: 500 }}>Chưa có ảnh</Typography>
                                                                        </Box>
                                                                    )}
                                                                </TableCell>
                                                                <TableCell sx={{ py: 2 }}>
                                                                    <Box
                                                                        sx={{
                                                                            maxHeight: 90,
                                                                            overflowY: "auto",
                                                                            fontSize: "13px",
                                                                            color: "#334155",
                                                                            pr: 1,
                                                                            "& p": { m: 0 },
                                                                            "& img": { maxWidth: "100%", borderRadius: "4px" }
                                                                        }}
                                                                    >
                                                                        <div dangerouslySetInnerHTML={{ __html: item.content || "<i style='color: #94a3b8;'>Chưa có nội dung</i>" }} />
                                                                    </Box>
                                                                </TableCell>
                                                                <TableCell align="center" sx={{ py: 2 }}>
                                                                    <Tooltip title={item.isShow ? "Đang hiển thị" : "Đã ẩn"}>
                                                                        <Chip
                                                                            icon={item.isShow ? <CheckCircleIcon sx={{ "&&": { fontSize: 16 } }} /> : <CancelIcon sx={{ "&&": { fontSize: 16 } }} />}
                                                                            label={item.isShow ? "Hiển thị" : "Đã ẩn"}
                                                                            size="small"
                                                                            color={item.isShow ? "success" : "default"}
                                                                            variant={item.isShow ? "filled" : "outlined"}
                                                                            onClick={() => handleToggleShow(item)}
                                                                            sx={{
                                                                                cursor: "pointer",
                                                                                fontWeight: 600,
                                                                                height: 26,
                                                                                fontSize: "12px"
                                                                            }}
                                                                        />
                                                                    </Tooltip>
                                                                </TableCell>
                                                                <TableCell align="center" sx={{ py: 2 }}>
                                                                    <Stack direction="row" spacing={0.5} justifyContent="center">
                                                                        <Tooltip title="Chỉnh sửa">
                                                                            <IconButton
                                                                                size="small"
                                                                                onClick={() => handleOpenEditModal(item)}
                                                                                sx={{
                                                                                    color: "#2563eb",
                                                                                    bgcolor: "rgba(37, 99, 235, 0.08)",
                                                                                    "&:hover": { bgcolor: "rgba(37, 99, 235, 0.16)" }
                                                                                }}
                                                                            >
                                                                                <EditIcon fontSize="small" />
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                        {idx > 0 && (
                                                                            <Tooltip title="Xóa thông báo">
                                                                                <IconButton
                                                                                    size="small"
                                                                                    onClick={() => handleDeleteNotify(item)}
                                                                                    sx={{
                                                                                        color: "#ef4444",
                                                                                        bgcolor: "rgba(239, 68, 68, 0.08)",
                                                                                        "&:hover": { bgcolor: "rgba(239, 68, 68, 0.16)" }
                                                                                    }}
                                                                                >
                                                                                    <DeleteIcon fontSize="small" />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        )}
                                                                    </Stack>
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })
                                                ) : (
                                                    <TableRow>
                                                        <TableCell colSpan={5} align="center" sx={{ py: 6, color: "#94a3b8" }}>
                                                            <PhotoLibraryIcon sx={{ fontSize: 40, mb: 1, opacity: 0.5 }} />
                                                            <Typography variant="body2">Không tìm thấy thông báo hoặc banner nào</Typography>
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </CardContent>
                            </Card>

                            {/* REDESIGNED DIALOG MODAL */}
                            <Dialog
                                open={isModalOpen}
                                onClose={() => setIsModalOpen(false)}
                                maxWidth="md"
                                fullWidth
                                PaperProps={{
                                    sx: {
                                        borderRadius: "16px",
                                        boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
                                        overflow: "hidden",
                                        maxHeight: "calc(100dvh - 32px)",
                                        display: "flex",
                                        flexDirection: "column"
                                    }
                                }}
                            >
                                <DialogTitle
                                    sx={{
                                        m: 0,
                                        p: 2.5,
                                        bgcolor: "#f8fafc",
                                        borderBottom: "1px solid #e2e8f0",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        flexShrink: 0
                                    }}
                                >
                                    <Stack direction="row" alignItems="center" spacing={1.5}>
                                        <CampaignIcon sx={{ color: "#2563eb", fontSize: 26 }} />
                                        <Typography variant="h6" sx={{ fontWeight: 700, fontSize: "18px", color: "#0f172a" }}>
                                            {modalMode === "create" ? "Thêm mới Banner / Thông báo" : "Chỉnh sửa Banner / Thông báo"}
                                        </Typography>
                                    </Stack>
                                    <IconButton onClick={() => setIsModalOpen(false)} size="small" sx={{ color: "#64748b" }}>
                                        <CloseIcon />
                                    </IconButton>
                                </DialogTitle>

                                <form onSubmit={handleFormSubmit} style={{ display: "flex", flexDirection: "column", minHeight: 0, flex: 1, overflow: "hidden" }}>
                                    <DialogContent sx={{ p: 3, overflowY: "auto", minHeight: 0, flex: 1, overscrollBehavior: "contain" }}>
                                        <Stack spacing={3}>
                                            {/* Select Type / Position */}
                                            {modalMode === "create" || (notifyItem && notifyItem.title !== "marquee" && notifyItem._id !== notify?.[1]?._id) ? (
                                                <FormControl fullWidth size="small">
                                                    <InputLabel id="notify-title-label" sx={{ fontWeight: 600 }}>Loại thông báo / Vị trí hiển thị</InputLabel>
                                                    <Select
                                                        labelId="notify-title-label"
                                                        value={selectedTitle}
                                                        label="Loại thông báo / Vị trí hiển thị"
                                                        onChange={(e) => setSelectedTitle(e.target.value)}
                                                        sx={{ borderRadius: "8px", fontWeight: 500 }}
                                                    >
                                                        <MenuItem value="popup">
                                                            <Box>
                                                                <Typography variant="body2" sx={{ fontWeight: 600 }}>popup</Typography>
                                                                <Typography variant="caption" sx={{ color: "#64748b" }}>Banner thông báo nổi khi vào trang chủ / game</Typography>
                                                            </Box>
                                                        </MenuItem>
                                                        <MenuItem value="banner">
                                                            <Box>
                                                                <Typography variant="body2" sx={{ fontWeight: 600 }}>banner</Typography>
                                                                <Typography variant="caption" sx={{ color: "#64748b" }}>Banner chạy trên slider trang chủ</Typography>
                                                            </Box>
                                                        </MenuItem>
                                                        <MenuItem value="banner_login">
                                                            <Box>
                                                                <Typography variant="body2" sx={{ fontWeight: 600 }}>banner_login</Typography>
                                                                <Typography variant="caption" sx={{ color: "#64748b" }}>Banner hiển thị trên màn hình đăng nhập</Typography>
                                                            </Box>
                                                        </MenuItem>
                                                        <MenuItem value="marquee">
                                                            <Box>
                                                                <Typography variant="body2" sx={{ fontWeight: 600 }}>marquee</Typography>
                                                                <Typography variant="caption" sx={{ color: "#64748b" }}>Thông báo chữ chạy ngang trên cùng trang web</Typography>
                                                            </Box>
                                                        </MenuItem>
                                                    </Select>
                                                </FormControl>
                                            ) : (
                                                <Box sx={{ p: 1.5, bgcolor: "#f1f5f9", borderRadius: "8px", border: "1px solid #e2e8f0" }}>
                                                    <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 600, display: "block" }}>Loại thông báo</Typography>
                                                    <Typography variant="body2" sx={{ fontWeight: 700, color: "#0f172a" }}>
                                                        {notifyItem?.title === "marquee" ? "Dòng Chạy Thông Báo (Marquee)" : notifyItem?.title}
                                                    </Typography>
                                                </Box>
                                            )}

                                            {/* Banner Image URL & Upload */}
                                            {selectedTitle !== "marquee" && notifyItem?.title !== "marquee" && (
                                                <Box>
                                                    <Typography variant="subtitle2" sx={{ fontWeight: 600, color: "#334155", mb: 1 }}>
                                                        Hình ảnh Banner
                                                    </Typography>
                                                    <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} alignItems="center" mb={1.5}>
                                                        <TextField
                                                            fullWidth
                                                            size="small"
                                                            placeholder="Nhập URL hình ảnh (VD: https://... hoặc /uploads/...)"
                                                            value={imageUrl}
                                                            onChange={(e) => setImageUrl(e.target.value)}
                                                            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
                                                        />
                                                        <input
                                                            type="file"
                                                            id="notify_file_upload"
                                                            accept="image/*"
                                                            style={{ display: "none" }}
                                                            onChange={handleUploadFile}
                                                        />
                                                        <Button
                                                            variant="outlined"
                                                            startIcon={uploading ? <CircularProgress size={16} /> : <CloudUploadIcon />}
                                                            onClick={() => document.getElementById("notify_file_upload").click()}
                                                            disabled={uploading}
                                                            sx={{
                                                                borderRadius: "8px",
                                                                px: 2.5,
                                                                py: 0.9,
                                                                whiteSpace: "nowrap",
                                                                textTransform: "none",
                                                                fontWeight: 600
                                                            }}
                                                        >
                                                            {uploading ? "Đang tải..." : "Tải ảnh lên"}
                                                        </Button>
                                                    </Stack>

                                                    {/* Live Image Preview */}
                                                    {imageUrl && (
                                                        <Box sx={{ p: 2, border: "1px solid #e2e8f0", borderRadius: "10px", bgcolor: "#f8fafc", position: "relative" }}>
                                                            <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1}>
                                                                <Typography variant="caption" sx={{ fontWeight: 600, color: "#475569" }}>Xem trước hình ảnh:</Typography>
                                                                <Button
                                                                    size="small"
                                                                    color="error"
                                                                    onClick={() => setImageUrl("")}
                                                                    sx={{ textTransform: "none", fontSize: "11px", py: 0 }}
                                                                >
                                                                    Xóa ảnh
                                                                </Button>
                                                            </Stack>
                                                            <Box sx={{ maxWidth: "100%", maxHeight: 180, display: "flex", justifyContent: "center", alignItems: "center", overflow: "hidden", borderRadius: "6px", bgcolor: "#ffffff", border: "1px solid #cbd5e1" }}>
                                                                <img
                                                                    src={formatImageUrl(imageUrl)}
                                                                    alt="Preview"
                                                                    style={{ maxHeight: 170, maxWidth: "100%", objectFit: "contain" }}
                                                                    onError={(e) => {
                                                                        e.target.onerror = null;
                                                                        e.target.src = "https://via.placeholder.com/400x200?text=L%E1%BB%97i+đ%C6%B0%E1%BB%9Dng+d%E1%BA%A5n+%E1%BA%A3nh";
                                                                    }}
                                                                />
                                                            </Box>
                                                        </Box>
                                                    )}
                                                </Box>
                                            )}

                                            {/* Content Rich Text Editor */}
                                            <Box>
                                                <Typography variant="subtitle2" sx={{ fontWeight: 600, color: "#334155", mb: 1 }}>
                                                    Nội dung thông báo {selectedTitle === "marquee" ? "(Chữ chạy)" : "(Hỗ trợ HTML & định dạng văn bản)"}
                                                </Typography>
                                                <Box
                                                    sx={{
                                                        "& .ql-toolbar": {
                                                            borderTopLeftRadius: "8px",
                                                            borderTopRightRadius: "8px",
                                                            border: "1px solid #cbd5e1",
                                                            bgcolor: "#f8fafc"
                                                        },
                                                        "& .ql-container": {
                                                            borderBottomLeftRadius: "8px",
                                                            borderBottomRightRadius: "8px",
                                                            border: "1px solid #cbd5e1",
                                                            minHeight: 180,
                                                            fontSize: "14px"
                                                        }
                                                    }}
                                                >
                                                    <ReactQuill
                                                        value={content}
                                                        onChange={setContent}
                                                        theme="snow"
                                                        modules={modules}
                                                        formats={formats}
                                                        ref={reactQuillRef}
                                                    />
                                                </Box>
                                            </Box>
                                        </Stack>
                                    </DialogContent>

                                    <Divider />

                                    <DialogActions sx={{ px: 3, py: 2, bgcolor: "#f8fafc", flexShrink: 0, borderTop: "1px solid #e2e8f0" }}>
                                        <Button
                                            variant="outlined"
                                            color="inherit"
                                            onClick={() => setIsModalOpen(false)}
                                            sx={{ borderRadius: "8px", textTransform: "none", fontWeight: 600 }}
                                        >
                                            Hủy bỏ
                                        </Button>
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            disabled={submitting}
                                            startIcon={submitting ? <CircularProgress size={18} color="inherit" /> : <CheckCircleIcon />}
                                            sx={{
                                                background: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
                                                borderRadius: "8px",
                                                px: 3,
                                                textTransform: "none",
                                                fontWeight: 600,
                                                boxShadow: "0 4px 12px rgba(37, 99, 235, 0.25)"
                                            }}
                                        >
                                            {submitting ? "Đang lưu..." : modalMode === "create" ? "Tạo thông báo mới" : "Lưu thay đổi"}
                                        </Button>
                                    </DialogActions>
                                </form>
                            </Dialog>
                        </Container>
                    </Box>
                ) : (
                    <div>{t("not_permission")}</div>
                )}
            </DashboardLayout>
        </ThemeProvider>
    );
}

export default SettingNotify;

